import { useMemo } from "react"

import { IShortClassStudent } from "api/reactQuery/queries/shortClassList.types"

import { Sort, SortingType } from "../Advance.utility"

interface SortedStudentsProps {
  students: IShortClassStudent[]
  sortBy: Sort
  sortOrder: SortingType
}

export const useSortedStudents = ({
  students,
  sortBy,
  sortOrder,
}: SortedStudentsProps) => {
  const sortedStudents = useMemo(() => {
    const sorted = [...students].sort((a, b) => {
      if (sortBy === "first_name" || sortBy === "last_name") {
        if (sortOrder === "asc") {
          return a[sortBy].localeCompare(b[sortBy])
        } else {
          return b[sortBy].localeCompare(a[sortBy])
        }
      }
      return 0
    })
    return sorted
  }, [students, sortBy, sortOrder])

  return sortedStudents
}
